import { useQuery } from 'react-query';

import { OFFER_KEY, OffersInfoRequest, getOfferInfo } from '@utils/backend-api/offer';
import { OfferOption } from '@utils/backend-api/subscribe';

const useOffers = (params: OffersInfoRequest) => {
  const { data, isLoading } = useQuery<OfferOption[]>(OFFER_KEY, () => getOfferInfo(params), {});
  return { data, isLoading };
};

export default useOffers;
